document.addEventListener('DOMContentLoaded', function () {

  // --- Carousel init helpers ---
  const galleryEl    = document.querySelector('.clean-design-v2 .mainProduct-gallery');
  const thumbsEl     = document.querySelector('.clean-design-v2 .mainProduct-thumbs');
  const galleryList  = galleryEl  ? galleryEl.querySelector('.splide__list')  : null;
  const thumbsList   = thumbsEl   ? thumbsEl.querySelector('.splide__list')   : null;

  // Snapshot all original slides (as cloned nodes) keyed by slugified data-img-name
  // We store pairs: { galleryLi, thumbLi, slug }
  // Exclude any clones Splide may have added if the script runs late
  var _allSlides = [];
  if (galleryList && thumbsList) {
    const gSlides = Array.from(galleryList.querySelectorAll('.splide__slide:not(.splide__slide--clone)'));
    const tSlides = Array.from(thumbsList.querySelectorAll('.splide__slide:not(.splide__slide--clone)'));
    gSlides.forEach(function(gLi, i) {
      // Normalize filename: lowercase, strip extension, remove non-alphanumeric chars
      var rawName = (gLi.dataset.imgName || '').toLowerCase();
      rawName = rawName.replace(/\.[a-z0-9]+$/, '');              // remove extension
      rawName = rawName.replace(/_[a-f0-9\-]{20,}$/, '');        // remove Shopify UUID suffixes
      rawName = rawName.replace(/[^a-z0-9]/g, '');               // keep only letters+digits
      _allSlides.push({
        galleryLi : gLi.cloneNode(true),
        thumbLi   : tSlides[i] ? tSlides[i].cloneNode(true) : null,
        slug      : rawName  // e.g. "hydrationtropicalpopsicle1"
      });
    });
  }
  
  // --- Recalculate option prices when the variant changes ---
  function recalcPricesForVariant(variantId) {
    if (typeof product === 'undefined' || !product.variants) return;
    const variant = product.variants.find(v => v.id == variantId);
    if (!variant) return;

    document.querySelectorAll('.clean-design-v2 .bcolors-tabs-option').forEach(option => {
      const qty        = parseInt(option.dataset.quantity, 10) || 1;
      const isSub      = !!option.dataset.sellingPlan;
      const fixedPrice = option.dataset.fixedPrice ? parseInt(option.dataset.fixedPrice, 10) * 100 : null;
      const discPct    = option.dataset.disccount ? parseFloat(option.dataset.disccount) : 0;

      // Pick the correct base price (subscription allocation vs. one-time)
      let basePrice = variant.price;
      if (isSub) {
        const planId = option.dataset.sellingPlan;
        const alloc  = (variant.selling_plan_allocations || [])
          .find(a => a.selling_plan_id == planId);
        if (alloc) basePrice = alloc.price;
      }

      const totalPrice = basePrice * qty;
      const discount   = totalPrice * (discPct / 100);
      let finalPrice   = totalPrice - discount;
      if (fixedPrice !== null && !isNaN(fixedPrice)) finalPrice = fixedPrice;

      // Update .final-price text
      const finalEl = option.querySelector('.final-price');
      if (finalEl) finalEl.textContent = '$' + (finalPrice / 100).toFixed(2);

      // Update .onsale-price text (when no fixed_compare_at override)
      const onsaleEl = option.querySelector('.onsale-price');
      if (onsaleEl && !option.dataset.fixedCompareAt) {
        if (qty > 1 && discPct > 0) {
          onsaleEl.textContent = '$' + (totalPrice / 100).toFixed(2);
        } else if (variant.compare_at_price) {
          onsaleEl.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
        } else if (isSub && finalPrice < variant.price) {
          onsaleEl.textContent = '$' + (variant.price / 100).toFixed(2);
        }
      }
    });

    // Update the Add to Cart button price using the currently selected option
    document.querySelectorAll('.clean-design-v2 .bcolors-form').forEach(form => {
      const selectedOption = form.querySelector('.bcolors-tabs-option.selected');
      const btn            = form.querySelector('.bcolors-add-to-cart');
      if (selectedOption && btn) {
        const priceText = selectedOption.querySelector('.final-price').textContent;
        const stripped  = btn.textContent.replace(/[\d$.]/g, '');
        btn.textContent = stripped + priceText;
      }
    });
  }

  var mainSplideOpts = {
    type      : 'slide',
    rewind    : false,
    pagination: false,
    arrows    : true,
  };
  var thumbsSplideOpts = {
    type        : 'slide',
    rewind      : false,
    perPage     : 5,
    gap         : 10,
    pagination  : false,
    isNavigation: true,
    arrows      : false,
  };

  var main       = new Splide( '.clean-design-v2 .mainProduct-gallery', mainSplideOpts );
  var thumbnails = new Splide( '.clean-design-v2 .mainProduct-thumbs',  thumbsSplideOpts );

  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();

  /**
   * Filter the gallery + thumbs carousel to only slides whose data-img-name
   * starts with variantSlug.  If no matches, show all slides (fallback).
   * Fully destroys + re-mounts both Splide instances so loop works correctly.
   */
  function filterCarouselBySlug(variantSlug) {
    if (!galleryList || !thumbsList || !_allSlides.length) return false;

    // variantSlug comes in already normalized (no spaces, no special chars)
    // _allSlides slugs are also normalized the same way
    // Use .includes() so "hydrationtropicalpopsicle1" matches "tropicalpopsicle"
    var matched = _allSlides.filter(function(s) {
      return variantSlug && s.slug.includes(variantSlug);
    });

    var slides = matched.length ? matched : _allSlides;

    // Destroy current instances
    main.destroy();
    thumbnails.destroy();

    // Rebuild list contents
    galleryList.innerHTML = '';
    thumbsList.innerHTML  = '';
    slides.forEach(function(s) {
      galleryList.appendChild(s.galleryLi.cloneNode(true));
      if (s.thumbLi) thumbsList.appendChild(s.thumbLi.cloneNode(true));
    });

    // Re-create and re-mount
    main       = new Splide( '.clean-design-v2 .mainProduct-gallery', mainSplideOpts );
    thumbnails = new Splide( '.clean-design-v2 .mainProduct-thumbs',  thumbsSplideOpts );
    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();

    return matched.length > 0;
  }

  const copyImageSource = (targetImg, sourceImg) => {
    if (!targetImg || !sourceImg) return;

    const nextSrc = sourceImg.currentSrc || sourceImg.src;
    if (!nextSrc) return;

    targetImg.src = nextSrc;
    targetImg.removeAttribute('srcset');
    targetImg.removeAttribute('sizes');
    targetImg.removeAttribute('data-src');
    targetImg.removeAttribute('data-srcset');
    targetImg.alt = sourceImg.alt || targetImg.alt || '';
  };

  const getFirstRealAndCloneImages = (containerSelector) => {
    const container = document.querySelector(containerSelector);
    if (!container) return [];

    const images = [];
    const firstRealImage = container.querySelector('.splide__slide:not(.splide__slide--clone) img');

    if (firstRealImage) {
      images.push(firstRealImage);
    }

    container.querySelectorAll('.splide__slide[data-splide-index="0"] img').forEach(image => {
      if (!images.includes(image)) {
        images.push(image);
      }
    });

    return images;
  };

  const updateGalleryFromPurchaseOptionImage = (optionImage) => {
    if (!optionImage) return;

    const galleryImages = getFirstRealAndCloneImages('#mainProduct-gallery');
    const thumbImages = getFirstRealAndCloneImages('#mainProduct-thumbs');

    galleryImages.forEach(image => copyImageSource(image, optionImage));
    thumbImages.forEach(image => copyImageSource(image, optionImage));

    if (main && typeof main.refresh === 'function') {
      main.refresh();
    }

    if (thumbnails && typeof thumbnails.refresh === 'function') {
      thumbnails.refresh();
    }

    if (main && typeof main.go === 'function') {
      main.go(0);
    }

    if (thumbnails && typeof thumbnails.go === 'function') {
      thumbnails.go(0);
    }
  };

  const closeIconElement = document.querySelector('.close-icon-img')
  const closeIconSrc = closeIconElement ? closeIconElement.src : '';

  const createSplide = ( divId, imageList ) => {
    const carousel = document.createElement('section');
    carousel.id = divId;
    carousel.className = 'splide';
    carousel.setAttribute('aria-label', 'Zoom gallery');

    const trackDiv = document.createElement('div');
    trackDiv.className = 'splide__track';

    const slideList = document.createElement('ul');
    slideList.className = 'splide__list';

    imageList.forEach(img => {
      const slideItem = document.createElement('li');
      slideItem.className = 'splide__slide';

      const image= document.createElement('img');
      image.src = img.src;
      image.alt = '';

      slideItem.appendChild(image);
      slideList.appendChild(slideItem);
    });

    trackDiv.appendChild(slideList);
    carousel.appendChild(trackDiv);

    return carousel;
  };

  const closeZoomGallery = ( zoomCarouselSP, zoomThumbnailsSP, zoomCarousel, zoomThumbnails ) => {
    document.body.classList.remove('mainProduct-zoomGallery-open');
    setTimeout(function() {
      destroySplide(zoomCarouselSP, zoomCarousel);
      destroySplide(zoomThumbnailsSP, zoomThumbnails);
      document.querySelector('.mainProduct-zoomGallery').remove();
    }, 300);
  }

  const destroySplide = ( splideInstance, container ) => {
    if ( splideInstance && splideInstance.destroy ) {
      splideInstance.destroy();
    }
    container.remove();
  }

  const initZoom = ( imageList, index ) => {
    const zoomGalleryDiv = document.createElement('div');
    zoomGalleryDiv.className = 'mainProduct-zoomGallery';
    document.body.appendChild(zoomGalleryDiv);

    const closeIcon = document.createElement('img');
    closeIcon.src = closeIconSrc;
    closeIcon.alt = 'Close';
    closeIcon.className = 'mainProduct-zoomGallery-close';
    zoomGalleryDiv.appendChild(closeIcon);

    const zoomCarousel = createSplide('zoom-carousel', imageList);
    const zoomThumbnails = createSplide('zoom-carousel-thumbs', imageList);

    zoomGalleryDiv.appendChild(zoomCarousel);
    zoomGalleryDiv.appendChild(zoomThumbnails);

    const windowHeight = window.innerHeight;
    const mainGalleryHeight = (windowHeight * 0.75) + 'px'; 

    var zoomCarouselSP = new Splide( zoomCarousel, {
      type: 'slide',
      pagination: false,
      arrows    : true,
      height: mainGalleryHeight,
      width: mainGalleryHeight,
      start: index || 0,
    } );
  
    var zoomThumbnailsSP = new Splide( zoomThumbnails, {
      perPage     : 6,
      gap         : 10,
      rewind      : false,
      pagination  : false,
      isNavigation: true,
      arrows      : false,
      width       : mainGalleryHeight,
      start       : index || 0,
    } );
  
    zoomCarouselSP.sync( zoomThumbnailsSP );
    zoomCarouselSP.mount();
    zoomThumbnailsSP.mount();

    document.body.classList.add('mainProduct-zoomGallery-open');
    setTimeout(function() {
      document.body.classList.add('mainProduct-zoomGallery-splideReady');
      setTimeout(function() {
        zoomCarouselSP.go(index);
        zoomThumbnailsSP.go(index);
      }, 500);
    }, 100);

    closeIcon.addEventListener('click', function(){
      closeZoomGallery( zoomCarouselSP, zoomThumbnailsSP, zoomCarousel, zoomThumbnails );
    });

    zoomGalleryDiv.addEventListener('click', function(e) {
      if ( e.target.classList.contains('mainProduct-zoomGallery') ) {
        closeZoomGallery( zoomCarouselSP, zoomThumbnailsSP, zoomCarousel, zoomThumbnails );
      }
    });
  };

  const galleryImages = document.querySelectorAll('.clean-design-v2 .mainProduct-gallery img');
  if ( galleryImages.length ) {
    galleryImages.forEach(img => {
      img.addEventListener('click', function() {
        const $parent = this.closest('.splide__list');
        const $slide = this.closest('.splide__slide');
        const index = Array.from($parent.children).indexOf($slide);
        const imageList = $parent.querySelectorAll('img');
        const windowWidth = window.innerWidth;
        if ( windowWidth > 900 ) initZoom(imageList, index);
        
      });
    });
  }

  const tabForms = document.querySelectorAll('.clean-design-v2 .bcolors-form');
  const gift_wrappers = document.querySelectorAll('.clean-design-v2 .bcolors-gift-wrapper');

  const updateProgressBar = (count, progressBar) => {
    const checkpoints = progressBar.querySelectorAll('.progress-bar-checkpoint');
    checkpoints.forEach((checkpoint, index) => {
      const checkIcon = checkpoint.querySelector('div');
      if ( index < count ) {
        checkIcon.classList.add('selected');
      } else {
        checkIcon.classList.remove('selected');
      }
    });
    if ( count ) {
      progressBar.style.setProperty('--progress', count == 3 ? '100%' : ( 16.6666 + ( (count - 1) * 33.33333 ) ) + '%');
    } else {
      progressBar.style.setProperty('--progress', '0%');
    }
  }

  const buildFrequencySelector = (option, frequencyInput) => {
    if (!frequencyInput) return '';

    frequencyInput.innerHTML = '';

    if (!option || !option.dataset.sellingPlan) {
      return '';
    }

    const planAttributes = Array.from(option.attributes)
      .filter(attr => attr.name.startsWith('data-plan-id-'))
      .sort((a, b) => {
        const aIndex = Number(a.name.replace('data-plan-id-', ''));
        const bIndex = Number(b.name.replace('data-plan-id-', ''));
        return aIndex - bIndex;
      });

    planAttributes.forEach(attr => {
      const planIndex = attr.name.replace('data-plan-id-', '');
      const planId = attr.value;
      const planName =
        option.getAttribute(`data-plan-name-${planIndex}`) || planId;

      const selectOption = document.createElement('option');
      selectOption.value = planId;
      selectOption.textContent = planName;

      frequencyInput.appendChild(selectOption);
    });

    const configuredPlanId = option.dataset.sellingPlan;

    const configuredPlanExists = Array.from(frequencyInput.options).some(
      frequencyOption => frequencyOption.value == configuredPlanId
    );

    if (!configuredPlanExists && configuredPlanId) {
      const configuredOption = document.createElement('option');
      configuredOption.value = configuredPlanId;
      configuredOption.textContent = configuredPlanId;
      frequencyInput.appendChild(configuredOption);
    }

    frequencyInput.value = configuredPlanId;

    return frequencyInput.value || configuredPlanId;
  }

  const selectOption = (option) => {
    if (!option) return;

    console.log('Selecting option:', option);
    const form = option.closest('.bcolors-form');
    const formOptions = form.querySelectorAll('.bcolors-tabs-option');
    const optionIndex = Array.from(formOptions).indexOf(option);

    tabForms.forEach(form => {
      const addToCartBtn = form.querySelectorAll('.bcolors-add-to-cart');
      const variant_selector = form.querySelector('.bcolors-variant-selector select');
      const formOptions = form.querySelectorAll('.bcolors-tabs-option');
      const quantity_input = form.querySelector('input[name="quantity"]');
      const frequency_input = form.querySelector('select.bcolorsFrequencySelect');
      const freebies_input = form.querySelector('input.freebies_list');
      const freebies_ids_input = form.querySelector('input.freebies_ids');
      const selectedOption = formOptions[optionIndex];

      if (!selectedOption) return;

      formOptions.forEach(o => o.classList.remove('selected'));
      selectedOption.classList.add('selected');

      const selectedPrice = selectedOption.querySelector('.final-price').textContent;

      addToCartBtn.forEach(btn => {
        const currentText = btn.textContent;
        const strippedText = currentText.replace(/[\d$.]/g, '');
        btn.textContent = strippedText + selectedPrice;

        if (selectedOption.dataset.soldOut == 'true') {
          btn.disabled = true;
          btn.classList.add('sold-out');
          btn.textContent = 'Sold Out';
        } else {
          btn.disabled = false;
          btn.classList.remove('sold-out');
        }
      });

      let selling_plan_id = '';

      if (selectedOption.dataset.sellingPlan) {
        selling_plan_id = selectedOption.dataset.sellingPlan;

        if (frequency_input) {
          selling_plan_id =
            buildFrequencySelector(selectedOption, frequency_input) ||
            selectedOption.dataset.sellingPlan;
        }
      }

      const variant_id_input = form.querySelector('.ptabs-variant-id');
      const selling_plan_id_input = form.querySelector('.ptabs-selling-plan');

      variant_id_input.value =
        variant_selector
          ? variant_selector.value
          : selectedOption.dataset.variantId || '';

      selling_plan_id_input.value = selling_plan_id;

      if (quantity_input) {
        quantity_input.value = selectedOption.dataset.quantity || '1';
      }

      if (selectedOption.dataset.freebies) {
        freebies_input.value = selectedOption.dataset.freebies;
      } else {
        freebies_input.value = '';
      }

      if (selectedOption.dataset.freebiesIds) {
        freebies_ids_input.value = selectedOption.dataset.freebiesIds;
      } else {
        freebies_ids_input.value = '';
      }
    });
    
    const selectedTab = form.querySelector('.bcolors-tabs-titles button.selected');

    gift_wrappers.forEach(gift_wrapper => {
      const progressBar = gift_wrapper.nextElementSibling;
      giftCount = 0;

      gift_wrapper.querySelectorAll('.bcolors-gift').forEach((gift, index) => {
        if (option.dataset['gift' + (index + 1)]) { 
          gift.classList.add('unlocked');
          giftCount++;
        } else { 
          gift.classList.remove('unlocked');
        }
      });

      if (selectedTab && selectedTab.dataset.purchaseType == 'otp') {
        gift_wrapper.classList.add('otp');
      } else {
        gift_wrapper.classList.remove('otp');
      }

      if (giftCount) {
        gift_wrapper.classList.remove('empty');
      } else {
        gift_wrapper.classList.add('empty');
      }

      if (progressBar) {
        updateProgressBar(giftCount, progressBar);
      }
    });

    const option_image = option.querySelector('img');
    updateGalleryFromPurchaseOptionImage(option_image);
  }

    
  gift_wrappers.forEach(gift_wrapper => {
    giftList = gift_wrapper.querySelectorAll('.bcolors-gift');
    giftList.forEach((gift, index) => {
      gift.addEventListener('click', function() {
        const gift_wrapper = this.closest('.bcolors-gift-wrapper');
        const selectedTab = document.querySelector('.bcolors-tabs-titles button.selected');
        const isOtp = selectedTab && selectedTab.dataset.purchaseType == 'otp';
        const gift = gift_wrapper.querySelectorAll('.bcolors-gift')[index];
        let popupLink = gift.dataset.popupLink;
        if ( isOtp ) {
          const popupLinkOtp = gift.dataset.popupLinkOtp;
          if ( popupLinkOtp ) {
            popupLink = popupLinkOtp;
          } else {
            return;
          }
        }
        if ( popupLink ) {
          const popup = document.getElementById(popupLink);
          if ( popup ) {
            document.body.classList.add('freebie-popup-open');
            popup.classList.add('open');
          }
        }

        if ( isOtp ) return;
        const progressBar = gift_wrapper.nextElementSibling;
        if ( progressBar.classList.contains('bcolors-progress-bar') && progressBar.style.display != 'none' ) {
          selectGift(index);
        }
        
      });
    });
  });

  const bogusPopupButton = document.querySelector('.bcolors-bogus-popup-text');
  if ( bogusPopupButton ) {
    bogusPopupButton.addEventListener('click', function() {
      let popupLink = bogusPopupButton.dataset.popupId;
      const popup = document.getElementById(popupLink);
      if ( popup ) {
        document.body.classList.add('bogus-popup-open');
        popup.classList.add('open');
      }
    });
  }

  const selectGift = ( index ) => {

    gift_wrappers.forEach(gift_wrapper => {
      giftList = gift_wrapper.querySelectorAll('.bcolors-gift');
      const progressBar = gift_wrapper.nextElementSibling;
      updateProgressBar(index + 1, progressBar);
      giftList.forEach((o, i) => {
        if ( i <= index ) {
          o.classList.add('unlocked');
        } else {
          o.classList.remove('unlocked');
        }
      });
    });
      
    const tabForm = document.querySelector('.clean-design-v2 .bcolors-form');
    const optionSelectors = tabForm.querySelectorAll('.bcolors-tabs-option');
    selectOption(optionSelectors[index]);
  }

  tabForms.forEach(form => {
    const tabSelectors = form.querySelectorAll('.bcolors-tabs-titles button');
    const tabContents = form.querySelectorAll('.bcolors-tabs-panel');
    const variant_id_input = form.querySelector('.ptabs-variant-id');
    const selling_plan_id_input = form.querySelector('.ptabs-selling-plan');

    const optionSelectors = form.querySelectorAll('.bcolors-tabs-option');
    const variant_selector = form.querySelector('.bcolors-variant-selector select');
    const frequency_selector = form.querySelector('select.bcolorsFrequencySelect');

    optionSelectors.forEach(option => {
      option.addEventListener('click', function () {
        optionSelectors.forEach(o => o.classList.remove('selected'));
        selectOption(option);
      });
      if ( option.classList.contains('selected') ) {
        selectOption(option);
      }
    });

    tabSelectors.forEach(tab => {
      tab.addEventListener('click', function () {
        if ( tab.classList.contains('selected') ) return;
        const index = Array.from(tabSelectors).indexOf(this);
        let currentSelectedIndex = 0;
        tabContents.forEach(content => {
          if ( content.classList.contains('selected') ) {
            const optionSelectorsPrev = content.querySelectorAll('.bcolors-tabs-option');
            const selectedOptionPrev = content.querySelector('.bcolors-tabs-option.selected');
            const selectedOptionPrevIndex = Array.from(optionSelectorsPrev).indexOf(selectedOptionPrev);
            currentSelectedIndex = selectedOptionPrevIndex;
          }
        });

        tabForms.forEach(form => {
          const tabContents = form.querySelectorAll('.bcolors-tabs-panel');
          tabContents.forEach(content => {
            if ( content.classList.contains('selected') ) {
              content.classList.remove('selected');
            }
          });
          const tabSelectors = form.querySelectorAll('.bcolors-tabs-titles button');
            tabSelectors.forEach(t => t.classList.remove('selected'));
          tabSelectors[index].classList.add('selected');
          const selectedTab = tabContents[index];
          selectedTab.classList.add('selected');
        });

        const selectedTab = tabContents[index];
        selectedTab.classList.add('selected');
        const optionSelectorsCurrent = selectedTab.querySelectorAll('.bcolors-tabs-option');
        selectOption(optionSelectorsCurrent[currentSelectedIndex]);
      });
    });

    if ( variant_selector ) {
      variant_selector.addEventListener('change', function() {
        variant_id_input.value = variant_selector.value;

        // Recalculate all option prices + CTA price for the newly selected variant
        recalcPricesForVariant(variant_selector.value);

        // --- Image filtering by variant name convention ---
        const selectedOption = variant_selector.options[variant_selector.selectedIndex];
        const variantTitle   = selectedOption ? selectedOption.text.trim() : '';

        // Normalize to pure alphanumeric (no spaces, no hyphens) — same as _allSlides slugs
        // e.g. "Tropical Popsicle" → "tropicalpopsicle"
        const variantSlug = variantTitle.toLowerCase().replace(/[^a-z0-9]/g, '');

        // filterCarouselBySlug destroys + remounts Splide with only matching slides.
        // Returns false if no match → fallback: show all + go to variant featured image.
        const filtered = filterCarouselBySlug(variantSlug);

        if (!filtered) {
          // Fallback: navigate to variant's featured image position
          const featuredMedia = getVariantById( this.value ) && getVariantById( this.value ).featured_media;
          if ( featuredMedia ) {
            thumbnails.go( featuredMedia.position - 1 );
          }
        }
      });

      // --- On page load: sync prices + CTA to the currently selected variant ---
      variant_id_input.value = variant_selector.value;
      recalcPricesForVariant(variant_selector.value);
    }

    if ( frequency_selector ) {
      frequency_selector.addEventListener('change', function() {
        selling_plan_id_input.value = frequency_selector.value;
      });
    }
    
  });

  const tabs = document.querySelectorAll('.clean-design-v2 .mpd_tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const content = this.querySelector('.mpd_tab-content');
      const isActive = content.style.display === 'block';
      document.querySelectorAll('.mpd_tab-content').forEach(c => {
        c.style.display = 'none';
      });
      tabs.forEach(t => t.classList.remove('selected'));
      content.style.display = isActive ? 'none' : 'block';
      if (!isActive) {
        this.classList.add('selected');
      }
    });
  });

  const nadCtas = document.querySelectorAll('.cta-button');
  if ( nadCtas ) {
    nadCtas.forEach(cta => {
      cta.addEventListener('click', function(e) {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
        e.preventDefault();
      });
    });
  }

  const yotpoStars = document.querySelectorAll('.clean-design-v2 .yotpo-widget-instance');
  if ( yotpoStars ) {
    yotpoStars.forEach(widget => {
      widget.addEventListener('click', function(e) {
        const reviewsTab = document.querySelector('.custom-reviews-wrapper');
        reviewsTab.scrollIntoView({ behavior: 'smooth' });
        e.preventDefault();
      });
    });
  }

  const freebiePopups = document.querySelectorAll('.pdp-freebie-popup');
  if ( freebiePopups.length ) {
    freebiePopups.forEach(popup => {
      const closeBtn = popup.querySelector('.nad3-close');
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('open');
        document.body.classList.remove('freebie-popup-open');
      });
      popup.addEventListener('click', function(e) {
        if ( e.target.classList.contains('pdp-freebie-popup') ) {
          popup.classList.remove('open');
          document.body.classList.remove('freebie-popup-open');
        }
      });
    });
  }

  const upsellCards = document.querySelectorAll('.nad3-upsell-card');
  if ( upsellCards.length ) {
    upsellCards.forEach(card => {
      card.addEventListener('click', function(e) {
        const popupLink = card.dataset.popupLink;
        if ( popupLink ) {
          gift_wrappers[0].querySelector([`.bcolors-gift[data-popup-link="${popupLink}"]`]).click();
          freebiePopups.forEach(popup => {
            popup.classList.remove('open');
          });
          const popup = document.getElementById(popupLink);
          if ( popup ) popup.classList.add('open');
        }
      });
    });
  }

  const popupCtas = document.querySelectorAll('.pdp-freebie-popup .nad3-cta');
  if ( popupCtas.length ) {
    popupCtas.forEach(cta => {
      cta.addEventListener('click', function() {
        cta.closest('.pdp-freebie-popup').classList.remove('open');
        document.body.classList.remove('freebie-popup-open');
        tabForms[0].querySelector('.add-to-cart').click();
      });
    });
  }

  function getVariantById(variantId) {
    return product.variants.find(variant => variant.id == variantId);
  }

  const addFreebiesToCart = (product) => {
    if ( !product.properties || !product.properties._freebies_ids ) return;
    const freebiesList = product.properties['_freebies_ids'] ? product.properties['_freebies_ids'].split(',') : [];
    const cartData = [];
    freebiesList.forEach(freebieId => {
      cartData.push({
        id: freebieId.replace(/\D/g, ''),
        quantity: product.quantity || 1,
        properties: {
          _freebie: true
        }
      });
    });

    if ( cartData.length == 0 ) return;

    console.log('Adding freebies to cart:', cartData);
    
    const formData = {
      items: cartData
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Freebies added to cart:', data);
      const rebuildCartEvent = new CustomEvent('cart:build', {
          detail: { data: data },
          bubbles: true,
          cancelable: true
      });
      document.dispatchEvent(rebuildCartEvent);
    })
    .catch(error => {
      console.error('Error adding freebies to cart:', error);
    });
  }

  // document.addEventListener('ajaxProduct:added', function(evt) {
  //   addFreebiesToCart(evt.detail.product);
  // });

  // document.addEventListener('cart:updated', function(evt) {
  //   console.log('Cart Removing started:', evt.detail);
  //   const itemsToRemove = {};
  //   evt.detail.cart.items.forEach(item => {
  //     if ( item.properties && item.properties._freebie ) {
  //       itemsToRemove[item.key] = 0;
  //     }
  //   });
  //   if ( Object.keys(itemsToRemove).length == 0 ) return;
  //   console.log('Removing freebies from cart:', itemsToRemove);

  //   fetch(window.Shopify.routes.root + 'cart/update.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Accept': 'application/json'
  //     },
  //     body: JSON.stringify({
  //       updates: itemsToRemove
  //     })
  //   })
  //   .then(response => response.json())
  //   .then(updatedCart => {
  //     console.log('Cart updated successfully:', updatedCart);
  //     if ( updatedCart.items.length > 0 ) {
  //       updatedCart.items.forEach(item => {
  //         addFreebiesToCart(item);
  //       });
  //     } else {
  //       const rebuildCartEvent = new CustomEvent('cart:build', {
  //           detail: { data: updatedCart },
  //           bubbles: true,
  //           cancelable: true
  //       });
  //       document.dispatchEvent(rebuildCartEvent);
  //     }
  //   })
  //   .catch(error => {
  //     console.error('Error updating cart:', error);
  //   });
  // });

  // tabForms.forEach(form => {
  //   const addToCartBtn = form.querySelectorAll('.bcolors-add-to-cart');
  //   addToCartBtn.forEach(btn => {
  //     btn.addEventListener('click', function(e) {
  //       e.preventDefault();
  //       const selectedOpt = this.closest('form').querySelector('.bcolors-tabs-option.selected');
  //       if ( selectedOpt && selectedOpt.dataset.bundledProduct ) {
  //         console.log('Bundled product - handle accordingly');
  //         const formData = {
  //           items: [
  //             {
  //               id: selectedOpt.dataset.bundledProduct,
  //               quantity: 1
  //             }
  //           ]
  //         }

  //         fetch('/cart/add.js', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //           body: JSON.stringify(formData)
  //         })
  //         .then(response => response.json())
  //         .then(data => {
  //           console.log('Bundled added to cart:', data);
  //           form.submit();
  //         })
  //         .catch(error => {
  //           console.error('Error adding freebies to cart:', error);
  //         });
  //       } else {
  //         form.submit();
  //       }
  //     });
  //   });
  // });

});
